import React from 'react'
import PropTypes from 'prop-types'
import { Modal as EPModal, Copy, Button, Flex, Image } from '@elparking/components'
import { FormattedMessage } from 'react-intl'

const SimpleModal = ({ isShown, title, subtitle, imageSrc, onClose, onAccept, acceptButtonText, showCloseButton }) => {
    return <EPModal isShown={isShown} onClose={onClose} width='812px' height={['100%', 'auto']} label=' ' showCloseButton={showCloseButton} showModalTitle={false} fullScreenMobile={false}>
        <Flex mt={['0px', '3em']} flexDirection='column'>
            {imageSrc && <Image src={imageSrc} width='200px' height='200px' alignSelf='center' alt='-' />}
            <Copy size={['large', 'xxLarge']} fontWeight='medium' textAlign='center' color='accent_dark' padding='1em 0em'>
                {title}
            </Copy>
            {subtitle && <Copy size={['small', 'medium']} fontWeight='regular' textAlign='center' color='accent_dark' padding='0 0 1em 0'>
                {subtitle}
            </Copy>}
            <Flex width={['100%', 'fit-content']} alignSelf='center' flexDirection='column' alignContent='center' mt='1em' mb={['0em', '1em']}>
                <Button onClick={onAccept} fontWeight='book' dataTest='accept-button-simple-modal'>
                    {acceptButtonText || <FormattedMessage defaultMessage='Entendido'/>}
                </Button>
            </Flex>
        </Flex>
    </EPModal>
}

SimpleModal.propTypes = {
    showCloseButton: PropTypes.bool,
    isShown: PropTypes.bool,
    title: PropTypes.node,
    subtitle: PropTypes.node,
    imageSrc: PropTypes.string,
    onClose: PropTypes.func,
    onAccept: PropTypes.func,
    acceptButtonText: PropTypes.node,
}
export default SimpleModal
